import { getLocalStorageContext } from '../localStorage/localStorageHelper';

// UBI expects that the interaction id that is returned when emitting a UI-Navigate event will be used also with the navigationStart event.
// However, the UI-navigate event is emitted before the actual navigation and the navigationStart event has to be emitted after (because this is not an SPA).

// I.e. this is a trick to make the interaction id be kept during the page reload.

// In order to not emit the navigation start event incorrectly, the interaction id expires after a few seconds.

const navigationStore = typeof window !== 'undefined' ? getLocalStorageContext('navigation') : undefined;

export const INTERACTION_ID_TTL = 15000; // milliseconds

export const setNavigationInteraction = (destination: string, interactionId: string) => {
  const expiry = new Date(new Date().getTime() + INTERACTION_ID_TTL);
  navigationStore?.setValue(destination, JSON.stringify({ interactionId, expiry: expiry.getTime() }));
};

export const getNavigationInteractionId = (destination: string): string | undefined => {
  const rawEntry = navigationStore?.getValue(destination);
  if (rawEntry) {
    try {
      const { interactionId, expiry } = JSON.parse(rawEntry);
      if (new Date(expiry) > new Date()) {
        navigationStore?.removeValue(destination);
        return interactionId;
      }
    } catch (e) {
      navigationStore?.removeValue(destination);
    }
  }
  return undefined;
};
